import { API_BASE } from '../lib/api-base';
import { signinUrl } from '../lib/signin-url';
import { useEffect } from 'react';

import { Home } from '../components/symphony/Home';
import { SymphonyWelcomeModal } from '../components/SymphonyWelcomeModal';


// The `/` landing has NO getServerSideProps by design. It used to run a server-side
// onboarding gate here, but a gSSP forces Next to fetch `/_next/data/<buildId>/index.json`
// on EVERY in-app client navigation to home — a blocking round-trip (~300–900ms) for
// what is only ever a cold-load concern. The gate moved to the custom express server
// (express-server.js → lib/onboarding-gate.js), which runs it ONLY on the home
// *document* request; client navigations to `/` are client-routed and now do zero
// server work. The home renders fully client-side (brand-forked below); the dashboard
// loads via /api/dashboard (prefetched on app mount).

/**
 * Background auth check. Fires in parallel with the initial render — if the
 * server says we have no session, redirect to Wix sign-in. Rendering is
 * never blocked: the animation starts immediately on mount.
 */
function useAuthRedirect() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;
    let cancelled = false;
    fetch(`${API_BASE}/api/auth/login`, { credentials: 'include' })
      .then((res) => {
        if (cancelled || res.ok) return;
        if (res.status === 401) {
          window.location.href = signinUrl(window.location.href);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
}

// The landing route. The chat is the always-mounted floating overlay (AppFrame →
// FloatingChat), which grows to fill the pane on the home route. So `/` renders only
// what sits BEHIND the chat — the home dashboard (Symphony) or the chat composer
// (Orion). The onboarding gate runs server-side on the document request (see
// express-server.js); the client auth redirect below runs regardless.
export default function OrionLanding() {
  useAuthRedirect();
  return <HomeSurface />;
}

function HomeSurface() {
  return (
    <>
      <Home />
      {/* One-time "Welcome to your new Symphony" notice (self-gates to not-yet-seen
          + not a fresh onboarder). */}
      <SymphonyWelcomeModal />
    </>
  );
}
